<style scoped lang="less">
.tables {
	padding: 0 0.8rem 1.2rem 0.8rem;
	background: #fff;
	box-sizing: border-box;

	.paginations {
		height: 3rem;
		line-height: 3rem;

		input {
			width: 3rem;
			height: 1.8rem;
			padding: 0 0 0 0.8rem;
			border: 1px solid #ccc;
		}
	}

	.tabsnum {
		height: 4rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		p {
			color: #333;
		}

		.elpagian {
			margin-right: 1rem;
		}
	}
}

.resourbtn {
	padding: 15px 10px;
	// border: 1px solid;
	background-color: #f7f7f7;

	/deep/ .el-button {
		i {
			margin-right: 5px;
			font-size: 16px;
		}

		span {
			margin-right: 0 !important;
		}
	}

	button {
		background-color: #0a68e3;
		border: none;
	}
	button:last-child {
		background-color: #ff8300;
	}

	button:nth-of-type(2) {
		background-color: #ff4168;
	}
}

.tabslis {
	button {
		color: #fff;
	}

	/deep/ th {
		text-align: center;
		color: #333;
		font-weight: 600 !important;
	}

	/deep/ td {
		text-align: center;
	}

	.scostatus {
		margin: auto;
		border-radius: 10px;
		color: #fff;
		width: 60px;
		// padding: 2px 0;
		font-size: 12px;
		background-color: #f41127;
	}
}

.manageselect {
	display: flex;
	// border: 1px solid;
	padding: 20px;
	background-color: #fff;
	box-sizing: 0 5px 5px 5px rgba(255, 255, 255, 0.6);
	border-radius: 10px;
	margin-bottom: 20px;
	.sclectlable {
		margin-right: 20px;
	}
}
</style>
<template>
	<div>
		<titles titlename="知识类别管理" titlecontent="这里可以管理知识类别" :mbx="paths"></titles>

		<div class="manageselect">
			<div class="sclectlable">
				<div><el-input placeholder="请输入知识类别名" v-model="input" clearable></el-input></div>
			</div>
			<!-- <div class="sclectlable">
				
				<div>
					<el-select v-model="value" placeholder="请选择专业">
						<el-option v-for="item in options" :key="item.pro_guid" :label="item.pro_name" :value="item.pro_guid"></el-option>
					</el-select>
				</div>
			</div> -->

			<div class="primarybtn"><el-button type="primary" icon="el-icon-search" @click="get()">搜索</el-button></div>
		</div>

		<div class="resourbtn">
			<el-button
				type="primary"
				size="small"
				icon="fa fa-plus"
				@click="
					dialogFormVisible = true;
					edad = 0;
					gwname = '';
				"
			>
				添加知识类别
			</el-button>
		</div>

		<div class="tables">
			<div class="tabslist">
				<!-- <div class="paginations">
					每页显示
					<input @change="changetablesize()" type="number" oninput="if(value>30)value=30;if(value<2)value=1" v-model="tabsnun" />
					行
				</div> -->
				<div class="tabslis">
					<template>
						<el-table :data="tableData" header-row-class-name="tablestitle" border style="width: 100%">
							<el-table-column type="selection" width="55"></el-table-column>
							<el-table-column label="知识类别名称" prop="SKY_KonwledgeName"></el-table-column>
							<el-table-column label="操作" fixed="right" width="300px">
								<template slot-scope="scope">
									<el-button plain size="mini" style="background-color: #0d6efd;" @click="changeprlist(scope.row)">编辑</el-button>
									<el-popconfirm title="是否删除该条记录？" @confirm="confirmpros(scope.row)">
										<el-button slot="reference" plain size="mini" style="background-color: #ec0f25;">删除</el-button>
									</el-popconfirm>
								</template>
							</el-table-column>
						</el-table>
					</template>
				</div>
				<div class="tabsnum">
					<p>
						显示
						<span>1</span>
						到
						<span>{{ tableData.length }}</span>
						,共
						<span>{{ tableData.length }}</span>
						条记录
					</p>
				</div>
			</div>
		</div>

		<el-dialog title="添加知识类别" :visible.sync="dialogFormVisible" center>
			<el-form :model="form">
				<el-form-item label="知识类别名称" :label-width="formLabelWidth">
					<el-input v-model="gwname" autocomplete="off" placeholder="请输入知识类别名称"></el-input>
				</el-form-item>
				<!-- <el-form-item label="选择专业" :label-width="formLabelWidth">
					<el-select v-model="zyguids" style="width: 100%;" placeholder="请选择专业">
						<el-option v-for="item in options" :key="item.pro_guid" :label="item.pro_name" :value="item.pro_guid"></el-option>
					</el-select>
				</el-form-item> -->
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="affprlist">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';

import { changeKonwledgeType, changeTypeUpdate, changeTypeAdd, changeTypeDelete } from '@/request/api/homesview/yunhomes/yunhom.js';

import AppOptions from '@/config/AppOptions.vue';

export default {
	data() {
		return {
			// 标题
			paths: [
				{
					path: '/basicmanage/testists',
					name: '基础管理'
				},
				{
					path: '/basicmanage/testists/knowledgecategory',
					name: '知识类别管理'
				}
			],
			tableData: [],
			input: '',
			// 专业筛选项列表
			options: [],
			value: '',
			tabindex: 1,
			totalall: 0,
			tabsnum: 0,
			tabsnun: 0,
			form: {
				name: '',
				zyguid: ''
			},
			gwname: '',
			zyguids: '',
			formLabelWidth: '120px',
			dialogFormVisible: false,
			edad: 0,
			praaguid: ''
		};
	},
	mounted() {
		this.get();
	},
	created() {
		AppOptions.appEmpty = false;
	},
	methods: {
		get() {
			let statobj = {
				SKY_KonwledgeName: this.input
			};
			changeKonwledgeType(statobj).then(res => {
				this.tableData = res.data.data;
			});
		},
		changeprlist(itm) {
			let itms = JSON.parse(JSON.stringify(itm));
			this.gwname = itms.SKY_KonwledgeName;
			this.zyguids = itms.pro_guid;
			this.dialogFormVisible = true;
			this.praaguid = itms.SKY_GUID;
			this.edad = 1;
		},

		affprlist() {
			this.form.name = this.gwname;

			let prgobj = {
				SKY_KonwledgeName: this.form.name
			};
			if (this.form.name == '') {
				this.$message('请输入类别名称');
				return;
			}

			if (this.edad == 0) {
				changeTypeAdd(prgobj).then(res => {
					if (res.data.code > 0) {
						this.$message.success(res.data.msg);
						this.dialogFormVisible = false;
						this.form = {};
						this.gwname = '';
						this.zyguids = '';
						this.get();
					}
				});
			} else {
				this.changeprname();
			}
		},
		confirmpros(itm) {
			let delectobj = {
				SKY_GUID: itm.SKY_GUID
			};
			changeTypeDelete(delectobj).then(res => {
				if (res.data.code > 0) {
					this.$message.success(res.data.msg);
					this.get();
				}
			});
		},
		changeprname() {
			this.form.name = this.gwname;
			this.form.zyguid = this.zyguids;

			let changeobj = {
				SKY_GUID: this.praaguid,
				SKY_KonwledgeName: this.form.name
			};

			if (this.form.name == '') {
				this.$message('请输入岗位名称');
				return;
			}
			changeTypeUpdate(changeobj).then(res => {
				if (res.data.code > 0) {
					this.$message.success(res.data.msg);
					this.dialogFormVisible = false;
					this.form = {};
					this.gwname = '';
					this.zyguids = '';
					this.get();
				}
			});
		},
		changecurr(val) {}
	},
	components: {
		titles
	}
};
</script>
